export default "__VITE_ASSET__DLVen2Yg__"